const UNSUPPORTED_IMAGE_FORMATS = ["image/heic", "image/heif"];
export default UNSUPPORTED_IMAGE_FORMATS;
